import React, { useEffect, useState } from "react";
import {
  IonBadge,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonSpinner,
  useIonToast,
} from "@ionic/react";
import { useParams } from "react-router";

import ReembolsosAPI from "src/services/reembolsos";

import Header from "src/components/Header";

const COLOR_ESTADO: Record<string, string> = {
  GENERADO: "warning",
  APROBADO: "success",
  RECHAZADO: "danger",
  OBSERVADO: "tertiary",
};

const LABEL_ESTADO: Record<string, string> = {
  GENERADO: "Pendiente de aprobación",
  APROBADO: "Aprobado",
  RECHAZADO: "Rechazado",
  OBSERVADO: "En revisión",
};

interface DetalleTraslado {
  id: number;
  fecha: string;
  orden: number;
  ps_origen: string;
  ps_destino: string;
  hora_salida?: string;
  hora_llegada?: string;
  cant_buses?: number;
  costo_pasaje?: number;
  monto?: number;
  distancia_metros?: number;
  duracion_segundos?: number;
  estado: string;
  origen: string;
  motivo_rechazo?: string;
  fecha_gestion?: string;
}

const formatearMonto = (monto?: number) =>
  monto === null || monto === undefined ? "-" : `${Math.round(monto).toLocaleString("es-PY")} Gs.`;

const ReembolsoPasajeDetalle: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [detalle, setDetalle] = useState<DetalleTraslado | null>(null);
  const [cargando, setCargando] = useState(true);
  const [present] = useIonToast();

  useEffect(() => {
    ReembolsosAPI.getDetalle(parseInt(id, 10))
      .then((response) => setDetalle(response.data))
      .catch(() =>
        present({
          message: "Ocurrió un error al cargar el detalle",
          duration: 5000,
        })
      )
      .finally(() => setCargando(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <IonPage>
      <Header titulo="Detalle del Traslado" />

      <IonContent id="reembolso-pasaje-detalle">
        <div className="container mb-4">
          {cargando && (
            <div className="ion-text-center ion-padding">
              <IonSpinner name="crescent" />
            </div>
          )}

          {!cargando && !detalle && (
            <IonCard>
              <IonCardContent>
                <p className="ion-text-center">No se encontró el traslado.</p>
              </IonCardContent>
            </IonCard>
          )}

          {!cargando && detalle && (
            <IonCard>
              <IonCardHeader>
                <IonCardTitle style={{ fontSize: "18px" }}>
                  {detalle.fecha}{" "}
                  <IonBadge color={COLOR_ESTADO[detalle.estado] || "medium"}>
                    {LABEL_ESTADO[detalle.estado] || detalle.estado}
                  </IonBadge>
                </IonCardTitle>
              </IonCardHeader>
              <IonCardContent style={{ paddingTop: 0 }}>
                <IonList>
                  <IonItem>
                    <IonLabel className="ion-text-wrap">
                      <h3>Origen</h3>
                      <p>{detalle.ps_origen || "-"}</p>
                      {detalle.hora_salida && <p>Salida: {detalle.hora_salida}</p>}
                    </IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel className="ion-text-wrap">
                      <h3>Destino</h3>
                      <p>{detalle.ps_destino || "-"}</p>
                      {detalle.hora_llegada && <p>Llegada: {detalle.hora_llegada}</p>}
                    </IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>
                      <h3>Buses necesarios</h3>
                      <p>{detalle.cant_buses === null || detalle.cant_buses === undefined ? "-" : detalle.cant_buses}</p>
                    </IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>
                      <h3>Costo por pasaje</h3>
                      <p>{formatearMonto(detalle.costo_pasaje)}</p>
                    </IonLabel>
                  </IonItem>
                  <IonItem>
                    <IonLabel>
                      <h3>Monto a reembolsar</h3>
                      <p>
                        <strong>{formatearMonto(detalle.monto)}</strong>
                      </p>
                    </IonLabel>
                  </IonItem>
                  {detalle.distancia_metros ? (
                    <IonItem>
                      <IonLabel>
                        <h3>Distancia estimada</h3>
                        <p>{(detalle.distancia_metros / 1000).toFixed(1)} km</p>
                      </IonLabel>
                    </IonItem>
                  ) : null}
                  {detalle.estado === "RECHAZADO" && detalle.motivo_rechazo && (
                    <IonItem>
                      <IonLabel className="ion-text-wrap">
                        <h3>Motivo del rechazo</h3>
                        <p>{detalle.motivo_rechazo}</p>
                      </IonLabel>
                    </IonItem>
                  )}
                  {detalle.estado === "OBSERVADO" && (
                    <IonItem>
                      <IonLabel className="ion-text-wrap">
                        <p>
                          Este traslado está siendo revisado por el equipo de gestión.
                        </p>
                      </IonLabel>
                    </IonItem>
                  )}
                </IonList>
              </IonCardContent>
            </IonCard>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default ReembolsoPasajeDetalle;
